
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
  @Component
export default class TeacherWork extends Vue {
    @Prop() tableData: any

    mounted() {
    }
}
